<template>
    <v-container fluid px-4 py-0 grid-list-lg>
        <v-layout row wrap>
            <v-flex sm12></v-flex>
            <v-flex sm12>
                <h3>User Administration</h3>
            </v-flex>
        </v-layout>
        <v-layout><v-flex></v-flex></v-layout>
        <v-layout row wrap>
            <v-flex xs12 md3 align-center>Search New Users</v-flex>
            <v-flex xs12 sm8 md6>
                <v-text-field v-model="newUserSearchDto.username" label="Enter Username/Email"></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2>
                <v-btn color="primary" @click="loadNewUsers">Search</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        New Users (setup required)
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="newUserTableFilter"
                            append-icon="search"
                            label="Filter"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                    :headers="userTableHeaders"
                    :items="newUserResults"
                    :search="newUserTableFilter"
                    :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs"><v-btn icon @click="editUser(props.item)"><v-icon>assignment</v-icon></v-btn></td>
                            <td class="text-xs">{{ props.item.countyName }}</td>
                            <td class="text-xs">{{ props.item.username }}</td>
                            <td class="text-xs">{{ props.item.firstName }}</td>
                            <td class="text-xs">{{ props.item.lastName }}</td>
                            <td class="text-xs">{{ props.item.roleName }}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout><v-flex><v-divider></v-divider></v-flex></v-layout>
        <v-layout row wrap>
            <v-flex xs12 align-center>Search Users</v-flex>
            <v-flex xs12 sm8 md6>
                <v-text-field v-model="userSearchDto.firstName" label="First Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 md6>
                <v-text-field v-model="userSearchDto.lastName" label="Last Name"></v-text-field>
            </v-flex>
            <v-flex xs12 sm8 md6>
                <v-text-field v-model="userSearchDto.username" label="Username/Email"></v-text-field>
            </v-flex>
            <v-flex xs6 sm4 md2>
                <v-btn color="primary" @click="loadUsers">Search</v-btn>
            </v-flex>
            <v-flex xs6 sm4 md2>
                <v-btn  @click="clearUserSearch">Clear</v-btn>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <v-card>
                    <v-card-title>
                        Users
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="userTableFilter"
                            append-icon="search"
                            label="Filter"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                    :headers="userTableHeaders"
                    :items="userResults"
                    :search="userTableFilter"
                    :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                    >
                        <template slot="items" slot-scope="props">
                            <td class="text-xs"><v-btn icon @click="editUser(props.item)"><v-icon>assignment</v-icon></v-btn></td>
                            <td class="text-xs">{{ props.item.countyName }}</td>
                            <td class="text-xs">{{ props.item.username }}</td>
                            <td class="text-xs">{{ props.item.firstName }}</td>
                            <td class="text-xs">{{ props.item.lastName }}</td>
                            <td class="text-xs">{{ props.item.roleName }}</td>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12>
                <v-dialog v-model="userEditDialog" persistent no-click-animation max-width="900px">
                    <v-card>
                        <v-card-title class="title grey lighten-3" primary-title>
                            Edit User
                        </v-card-title>
                        <v-card-text>
                            <v-form ref="userForm" v-model="formValid">
                                <!-- <v-layout row wrap>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.username" label="Username/Email" :rules="[v => !!v || 'Username is required']" required>></v-text-field>
                                    </v-flex>
                                </v-layout> -->
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.firstName" label="First Name" :rules="[v => !!v || 'First Name is required']" required></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 px-1>
                                        <v-text-field v-model="selectedUser.lastName" label="Last Name" :rules="[v => !!v || 'Last Name is required']" required></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 sm6 px-1>
                                        <v-autocomplete :readonly="!isAdmin" :disabled="isAdmin && !userCountyEdit" browser-autocomplete='no' v-model="selectedUserCountyId" :items="countyList" item-text="description"
                                        item-value="id" label="County"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs6 sm4 md2 >
                                        <v-btn v-if="isAdmin" color="primary" @click="userCountyEdit = true">Change County</v-btn>
                                        <v-btn v-else color="primary" @click="assignCounty">Assign County</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 v-if="selectedUserRoleList.every(n => n !== 8000)">
                                        <v-autocomplete browser-autocomplete='no' dense chips deletable-chips multiple persistent-hint v-model="selectedUserRoleList" :items="roleList" item-text="description"
                                        item-value="id" label="User Role(s)" ></v-autocomplete>
                                    </v-flex>
                                    <v-layout row wrap v-if="selectedUserRoleList.some(n => n === 8000)">
                                        <v-flex xs12 md9>
                                            <v-autocomplete browser-autocomplete='no' dense chips deletable-chips multiple persistent-hint v-model="selectedUserRoleList" :items="roleList" item-text="description"
                                            item-value="id" label="User Role(s)" ></v-autocomplete>
                                        </v-flex>
                                        <v-flex xs12 md3>
                                            <v-select dense :items="pathologistTitleList" v-model="selectedUser.titleId" item-text="description"
                                            item-value="id" label="Select Pathologist Title"
                                            :rules="[v => !!v || 'Pathologist Title is required']" required>
                                        </v-select>
                                        </v-flex>
                                    </v-layout>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs12 v-if="validationResult.messages && validationResult.messages.length > 0">
                                        <validationResultDisplay :validationResult="validationResult"></validationResultDisplay>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                        <v-card-actions py-1>
                            <v-btn color="error" @click="removeUser" v-if="!selectedUser.userRoleList || selectedUser.userRoleList.length < 1">Remove User</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="saveUser" flat>Save User</v-btn>
                            <v-btn color="primary" @click="userEditDialog = false; userCountyEdit = false" flat>Close</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import loggingService from '@/services/util/loggingService'
import userService from '@/services/userService'
import lookupService from '@/services/lookup/lookupService'

import loader from '@/components/Loader'
import validationResultDisplay from '@/components/ValidationResultDisplay.vue'

export default {
    name: 'UserAdministration',
    components: {
        loader,
        validationResultDisplay
    },
    props: {
        coronerUserDto: {}
    },
    data: function () {
        return {
            isDebug: false,
            validationResult: {},
            countyList: [],
            roleList: [],
            newUserSearchDto: {},
            userSearchDto: {},
            userTableFilter: '',
            newUserTableFilter: '',
            userTableHeaders: [
                { text: 'Edit', sortable: 'false', value: 'userId' },
                { text: 'County', value: 'countyName' },
                { text: 'Username/Email', value: 'userName' },
                { text: 'First Name', value: 'firstName' },
                { text: 'Last Name', value: 'lastname' },
                { text: 'User Role', value: 'roleName' }
            ],
            userResults: [],
            newUserResults: [],
            pathologistTitleList: [],
            formValid: false,
            userEditDialog: false,
            selectedUser: {},
            selectedUserCountyId: null,
            selectedUserRoleList: [],
            userCountyEdit: false
        }
    },
    computed: {
        isAdmin: function () {
            return (this.coronerUserDto && userService.isAdministrator(this.coronerUserDto.roleList))
        },
        currentUserCounty: function () {
            return this.coronerUserDto ? this.coronerUserDto.primaryCountyId : null
        }
    },
    mounted () {
        this.loadAll()
    },
    methods: {
        log (message) {
            return loggingService.log(this.isDebug, 'Case-Initial', message)
        },
        loadLookup (lookupName, dataName) {
            return lookupService.listLookup(this.$http, lookupName).then(response => {
                this[dataName] = response.data
            })
        },
        loadLookups () {
            this.log('loading lookus')
            Promise.all([
                this.loadLookup('County', 'countyList'),
                this.loadLookup('Role', 'roleList'),
                this.loadLookup('Title', 'pathologistTitleList')
            ]).then(response => {
                this.countyList.unshift({id: null, description: 'None'})
                return response
            })
        },
        loadUsers () {
            this.log('loading users')
            userService.listUserResultDtos(this.$http, this.userSearchDto).then(response => {
                this.userResults = response.data
                this.userResults.forEach(user => {
                    user.countyName = (user.userCountyList[0] || {countyName: ''}).countyName
                    user.roleName = (user.userRoleList[0] || {roleName: ''}).roleName
                })
            })
        },
        loadNewUsers () {
            this.log('loading new users')
            userService.searchNewUsers(this.$http, this.newUserSearchDto).then(response => {
                this.newUserResults = response.data
                this.newUserResults.forEach(user => {
                    user.countyName = (user.userCountyList[0] || {countyName: ''}).countyName
                    user.roleName = (user.userRoleList[0] || {roleName: ''}).roleName
                })
            })
        },
        loadAll () {
            Promise.all([this.loadLookups(), this.loadUsers(), this.loadNewUsers()]).then(response => {
                this.log('Done with all loading')
            })
        },
        editUser (user) {
            this.selectedUser = user
            this.selectedUserCountyId = (user.userCountyList[0] || {countyId: null}).countyId
            this.selectedUserRoleList = user.userRoleList.map(x => {
                return x.roleId
            })
            this.userEditDialog = true
        },
        saveUser () {
            this.userCountyEdit = false
            this.log('saving user id: ' + this.selectedUser.userId)
            if (this.$refs.userForm.validate()) {
                this.validationResult = {}
                //map userCountyList and userRoleList
                if (!this.isAdmin) {
                    //if user is currently assigned to another county, do not save
                    if (!this.selectedUserCountyId ||
                        (this.selectedUser.countyList &&
                            !this.selectedUser.countyList.find(x => x.countyId === this.currentUserCounty)
                        )
                    ) {
                        var msg = !this.selectedUserCountyId ? 'Cannot save this user, must assign a county first'
                            : 'Cannot edit and save this user, user belongs to a different county.'
                        alert(msg)
                        this.loadUsers()
                        this.loadNewUsers()
                        this.userEditDialog = !this.selectedUserCountyId
                        return
                    }
                    //county admin can only assign new users to its own county or no county
                    if (this.selectedUserCountyId && this.selectedUserCountyId !== this.currentUserCounty) {
                        this.selectedUserCountyId = this.currentUserCounty
                    }
                }
                this.selectedUser.userCountyList = this.selectedUserCountyId
                    ? [ { countyId: this.selectedUserCountyId, isPrimary: true } ]
                    : []

                this.selectedUser.userRoleList = this.selectedUserRoleList.map(x => {
                    return { roleId: x }
                })
                userService.saveUser(this.$http, this.selectedUser).then(response => {
                    if (response.data.isValid) {
                        this.loadUsers()
                        this.loadNewUsers()
                        this.userEditDialog = false
                    } else {
                        this.validationResult = response.data
                    }
                })
            } else {
                this.log('Form failed validation, cannot save.')
            }
        },
        //function to assign County to the user's own county
        assignCounty () {
            this.selectedUserCountyId = this.currentUserCounty
        },
        removeUser () {
            if (confirm('Are you sure you want to remove this user?')) {
                if (!this.isAdmin) {
                    //if user is currently assigned to another county, do not save
                    if (this.selectedUser.countyList &&
                            !this.selectedUser.countyList.find(x => x.countyId === this.currentUserCounty)
                    ) {
                        var msg = 'Cannot remove this user, user belongs to a different county.'
                        alert(msg)
                        this.loadUsers()
                        this.loadNewUsers()
                        this.userEditDialog = false
                        return
                    }
                }
                userService.setUserInactive(this.$http, this.selectedUser).then(response => {
                    if (response.data.isValid) {
                        this.loadUsers()
                        this.loadNewUsers()
                        this.userEditDialog = false
                    } else {
                        this.validationResult = response.data
                    }
                })
            }
        },
        clearUserSearch () {
            this.userSearchDto = {}
        }
    }
}
</script>
